import {ChangeDetectionStrategy, Component, computed, inject, input, Signal} from '@angular/core';
import {Carousel} from "primeng/carousel";
import {PrimeTemplate} from "primeng/api";
import {ABService} from "../../../services/a-b.service";
import {RouterLink} from "@angular/router";
import {ButtonDirective} from "primeng/button";
import {whiteButtonDt} from "../../../theme";

@Component({
  selector: 'homey-review-carousel',
  imports: [
    Carousel,
    PrimeTemplate,
    RouterLink,
    ButtonDirective
  ],
  templateUrl: './review-carousel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewCarouselComponent {
  private readonly abService = inject(ABService);
  private readonly reviewsStyle = this.abService.reviewsStyle;
  public readonly articleLinksEnabled = input(false);
  protected readonly whiteButtonDt = whiteButtonDt;

  carouselData: Signal<{
    name: string;
    color: string;
    review: string;
    photo: string;
    articleSlug?: string;
    storyPronoun?: string;
  }[]> = computed(() => {
        return [{
          name: 'Mathias & Inês',
          color: 'bg-blue-500',
          photo: '/assets/landing-page/reviews/mathias.webp',
          review: 'We got selected after only 4 months, honestly didn’t expect it. It couldn\'t have been easier.',
          articleSlug: 'mathias-ines-story',
          storyPronoun: 'their'
        }, {
          name: 'Hanna',
          color: 'bg-orange-500',
          photo: '/assets/landing-page/reviews/hanna.webp',
          review: 'I love NYC and I want to live here long-term, but I was overwhelmed by the paperwork. Homey made the housing lottery super easy!',
        }, {
          name: 'Bianca',
          color: 'bg-blue-500',
          photo: '/assets/landing-page/reviews/bianca.webp',
          review: 'I\'m so happy! I can\'t believe I got selected for the housing lottery! Homey did all of the work for me.',
          articleSlug: 'bianca-story',
          storyPronoun: 'her'
        }, {
          name: 'Kris',
          color: 'bg-orange-500',
          photo: '/assets/landing-page/reviews/kris.webp',
          review: 'Homey has been a lifesaver! I\'m a native New Yorker and I can\'t wait to finally be able to have a place of my own here.'
        },
        ];
    }
  );

}
